export const appToaster = {
  successHead: 'Success',
  errorHead: 'An Error Occurred',
  apiErrorHead: 'Error',
  loginSucess: 'You have successfully login',
  logoutSucess: 'You have successfully log out'
};
